import { SxProps, Theme } from '@mui/system';

export const datePicker: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    height: '40px',
    width: '205px',
  },
};

